import { UnionMap } from '../../../../types/union-map';

export type ResourceUserState = 'Unknown' | 'IsUser' | 'IsNotUser';

export const ResourceUserState: UnionMap<ResourceUserState> = {
    Unknown: 'Unknown',
    IsUser: 'IsUser',
    IsNotUser: 'IsNotUser',
};
